module.exports = __webpack_public_path__ + "core-img/date-input-144dpi.2f68eea7dec01e20aa60b5d7048313e5.png";


//////////////////
// WEBPACK FOOTER
// ./src/main/ui/core/gfx/date-input-144dpi.png
// module id = 81
// module chunks = 0